import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddQuestion from "../../../containers/admin/questions-bank/models/add-question";
import SearchBar from "../../../containers/admin/questions-bank/searchbar";
import QuestionsBankTable from "../../../containers/admin/questions-bank/table";
import { getQuestionBankByBucketRequest } from "../../../modules/superadmin-modules/questions-bank/Actions";
const QuestionsBank = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [bucketId, setBucketId] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    if (bucketId) dispatch(getQuestionBankByBucketRequest(bucketId));
  }, [bucketId]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        setBucketId={setBucketId}
      />
      <QuestionsBankTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddQuestion
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default QuestionsBank;
